import createInstance from "@emotion/css/create-instance";

export const emotionKey = "site";

export const emotion = createInstance({ key: emotionKey });
export const { css } = emotion;
